// extracted by mini-css-extract-plugin
export var badge = "_g0-2";
export var detailsPanel = "_g0-0";
export var resultRow = "_g0-1";